"use strict";
/*
 * Created on 26. 1. 2021
 *
 * Copyright (c) 2021 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var big_decimal_1 = require("@logio/big-decimal");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var DashboardPromoType_1 = require("../sales-dashboard/DashboardPromoType");
/**
 * @author Radim Krkoška
 */


var SalesDashboardComparatorItem =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SalesDashboardComparatorItem, _DomainObject_1$Domai);

  /**
   * @param volumeDiff
   * @param costValueDiff
   * @param title
   * @param promoType
   * @param simulation
   * @param volumeSDR
   * @param volumePPR
   * @param costValueSDR
   * @param costValuePPR
   */
  function SalesDashboardComparatorItem(volumeDiff, costValueDiff, title, promoType, simulation, volumeSDR, volumePPR, costValueSDR, costValuePPR) {
    var _this;

    _classCallCheck(this, SalesDashboardComparatorItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SalesDashboardComparatorItem).call(this));
    _this.volumeDiff = volumeDiff;
    _this.costValueDiff = costValueDiff;
    _this.title = title;
    _this.promoType = promoType;
    _this.simulation = simulation;
    _this.volumeSDR = volumeSDR;
    _this.volumePPR = volumePPR;
    _this.costValueSDR = costValueSDR;
    _this.costValuePPR = costValuePPR;
    return _this;
  }
  /**
   * Creates empty {@link SalesDashboardComparatorItem} instance.
   */


  _createClass(SalesDashboardComparatorItem, null, [{
    key: "empty",
    value: function empty() {
      return new SalesDashboardComparatorItem(big_decimal_1.bigdecimal(0), big_decimal_1.bigdecimal(0), '', DashboardPromoType_1.DashboardPromoType.Leaflet, false, big_decimal_1.bigdecimal(0), big_decimal_1.bigdecimal(0), big_decimal_1.bigdecimal(0), big_decimal_1.bigdecimal(0));
    }
  }]);

  return SalesDashboardComparatorItem;
}(DomainObject_1.DomainObject);

exports.SalesDashboardComparatorItem = SalesDashboardComparatorItem;
/**
 * @inheritDoc
 */

SalesDashboardComparatorItem.schema = function () {
  var bld = new StructPropBuilder_1.StructPropBuilder(SalesDashboardComparatorItem.name);
  return {
    volumeDiff: bld.bigNum('volumeDiff'),
    costValueDiff: bld.bigNum('costValueDiff'),
    title: bld.str('title'),
    promoType: bld.senum('promoType', DashboardPromoType_1.DashboardPromoType, 'lookup-promo-type'),
    simulation: bld.bool('simulation'),
    volumeSDR: bld.bigNum('volumeSDR'),
    volumePPR: bld.bigNum('volumePPR'),
    costValueSDR: bld.bigNum('costValueSDR'),
    costValuePPR: bld.bigNum('costValuePPR')
  };
}();